jQuery(function ($) {

    jQuery('.resource-type-taxonomy-ul .product-list, .business-list, .client-list').on('click', function (e) {

        pageval = $('.page-resource-pagination .current').attr('data-href');
        pageval = parseInt(pageval);
        var target = $(e.target);
        if (target.is(".product-list")) {
            //e.target.value;

            ajaxTestFunction(pageval, this);
        } else {
            ajaxTestFunction();
        }
        
    });

    currentVal = "1";

    // Wrap the AJAX call to `test_function` in a `function`.
    function ajaxTestFunction(page_num, this_var) {

        if (isNaN(page_num)) {
            page_num = 1;
        }

        console.log("page no" + page_num);
        filter_val1 = '';
        filter_val2 = '';
        filter_val2 = '';

        search_val = $('#s').val();

        console.log("search" + search_val);

        if ($(this_var).hasClass('type')) {
            if ($(this_var).prop("checked") == true) {
                filter_val1 = $(this_var).val();
            }
            taxonomy1 = $('.type').attr('data');
            console.log("if");
        } else {
            taxonomy1 = $('.type').attr('data');
            $.each($('.type'), function () {
                if ($(this).prop("checked") == true) {
                    filter_val1 = $(this).val();
                }
            });
            console.log("else");
        }

        console.log("first taxonomy " + taxonomy1);

        var business = [];
        taxonomy2 = $('.business').attr('data');
        $.each($(".business"), function () {
            if ($(this).prop("checked") == true) {
                business.push("'" + $(this).val() + "'");

            }
        });
        filter_val2 = business.join(", ");

        var client = [];
        taxonomy3 = $('.client').attr('data');
        $.each($(".client"), function () {
            if ($(this).prop("checked") == true) {
                client.push($(this).val());

            }
        });
        filter_val3 = client.join(", ");

        console.log("filter 1" + filter_val1);
        console.log("filter 2" + filter_val2);
        console.log("filter 3" + filter_val3);

        $.ajax({
            type: 'GET',
            cache: true,
            url: waystar_params.endpoint,
            data: {
                _ajax_nonce: waystar_params.security,
                action: 'filter_post',
                filter_value1: filter_val1,
                filter_value2: filter_val2,
                filter_value3: filter_val3,
                taxonomy_value1: taxonomy1,
                taxonomy_value2: taxonomy2,
                taxonomy_value3: taxonomy3,
                search_value: search_val,
                paged: page_num || 1
            },
            success: function (data) {
                //console.log('success');
                $('.resource-list-wrapper').html(data);
                lazy_load();
            }
        });
    }


    var timeoutID = null;

    function findMember(str) {
        console.log('search: ' + str);
        var paged = /[\?&]paged=(\d+)/.test(this.href) && RegExp.$1;

        ajaxTestFunction(paged);
    }

    $('.search-box').on('keydown', function (e) {
        console.log('keydown');
        if (e.which == 9) { //tab

            pageval = $('.page-resource-pagination .current').attr('data-href');
            pageval = parseInt(pageval);
            ajaxTestFunction(pageval);
            console.log("tab keydown: " + pageval);
        }
    });
    $('.search-box').on('keypress', function (e) {
        console.log('keypress');
        if (e.which == 13) {  // enter

            pageval = $('.page-resource-pagination .current').attr('data-href');
            pageval = parseInt(pageval);
            ajaxTestFunction(pageval);
            console.log("enter keypress: " + pageval);
        }

    });
    $('.search-icon').on('click', function (e) {

        searchbox_val = $('.search-box').val();

        timeoutID = setTimeout(findMember(searchbox_val), 500);
    });

    $(document).on('click', '.page-resource-pagination .page-link', function (e) {

        e.preventDefault();
        // pageval= $(this).text();
        pageval = $(this).attr('data-href');

        pageval = parseInt(pageval);
        ajaxTestFunction(pageval);
        $(window).scrollTop($("#layout-content").offset().top);

    });

});